<template>
  <vue-js-modal
    v-if="geoInput"
    :key="reload"
    id="agGeoInputModal"
    class="agModal"
    name="agGeoInputModal"
    draggable=".card-header"
    width="75%"
    height="85%"
    :shiftX=".5"
    :shiftY=".25"
    :resizable="true"
    :clickToClose="false">
    <b-card>
      <template #header>
        <h4 v-if="geoInput._id" class="agModal-title">Edit GeoInput {{geoInput.shortname}}</h4>
        <h4 v-else class="agModal-title">New GeoInput {{geoInput.shortname}}</h4>
      </template>
    <div class="agInputGroup agInputGroupCentered">
      <label>Source:</label>
      <b-input type="text" :value="srcStr" autocomplete="false" disabled></b-input>
    </div>
    <b-input-group size="md" prepend="Name">
      <b-input type="text" v-model="geoInput.name" autocomplete="false" :disabled="disableUI || isLoading"></b-input>
    </b-input-group>
    <b-input-group size="md" prepend="Description">
      <b-input type="text" v-model="geoInput.description" autocomplete="false" :disabled="disableUI || isLoading"></b-input>
    </b-input-group>
    <hr />
    <div class="agInputGroup agInputGroupCentered">
      <label>Type:</label>
      <b-form-select
        class="agMediumInput" 
        v-model="geoInput.subtype"
        :options="types"
        :disabled="disableUI || isLoading"
        @change="typeField_change">
      </b-form-select>
    </div>
    <hr />

    <!-- Components based on type -->

    <ag-geoInput-buffer
      v-if="geoInput.subtype=='buffer'"
      ref="buffer"
      :disableUI="disableUI || isLoading"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-buffer>

    <ag-geoInput-distance
      v-if="geoInput.subtype=='distance'"
      ref="distance"
      :disableUI="disableUI || isLoading"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-distance>

    <ag-geoInput-geocode
      v-if="geoInput.subtype=='geocode'"
      ref="geocode"
      :disableUI="disableUI || isLoading"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-geocode>

    <ag-geoInput-nearestFeature
      v-if="geoInput.subtype=='nearestFeature'"
      ref="nearestFeature"
      :disableUI="disableUI || isLoading"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-nearestFeature>

    <ag-geoInput-gisExtension
      v-if="geoInput.subtype=='gisExtension'"
      ref="gisExtension"
      :disableUI="disableUI || isLoading"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-gisExtension>

     <ag-geoInput-intersect
      v-if="geoInput.subtype=='intersect'"
      ref="intersect"
      :disableUI="disableUI || isLoading"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-intersect>

    <ag-geoInput-project
      v-if="geoInput.subtype=='project'"
      ref="project"
      :disableUI="disableUI || isLoading"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-project>

    <ag-geoInput-reverseGeocode
      v-if="geoInput.subtype=='reverseGeocode'"
      ref="reverseGeocode"
      :disableUI="disableUI || isLoading"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-reverseGeocode>

    <hr />
    <div class="agInputGroup agInputGroupCentered">
      <label>Destination:</label>
      <b-input type="text" :value="destName" class="agInput agExtraSmallInput" disabled></b-input>
    </div>

    <template #footer>
        <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
        <div v-else-if="modalMessage">
          <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
        </div>

        <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
        <b-button
          class="agModal-buttonRight"
          variant="primary"
          :disabled="disableUI || isLoading"
          @click="saveButton_click">
          Save
        </b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          :disabled="disableUI || isLoading"
          @click="deleteButton_click">
          Delete
        </b-button>
      </template>
    </b-card>

    <!-- delete modal -->
    <b-modal
      class="agModal"
      ref="deleteModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="deleteButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete GeoInput</h4>
      </template>
      Are you sure you want to delete geoinput
      <i>{{ name }}</i>?
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button class="agModal-buttonLeft" @click="cancel">
          Cancel
        </b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          @click="confirmDeleteButton_click">
          Delete
        </b-button>
      </template>
    </b-modal>

  </vue-js-modal>
</template>






<script>
// components
import Buffer from "nodes/geoInputs/Buffer";
import Distance from "nodes/geoInputs/Distance";
import Geocode from "nodes/geoInputs/Geocode";
import NearestFeature from "nodes/geoInputs/NearestFeature";
import GISExtension from "nodes/geoInputs/GISExtension";
import Intersect from "nodes/geoInputs/Intersect";
import Project from "nodes/geoInputs/Project";
import ReverseGeocode from "nodes/geoInputs/ReverseGeocode";

// modules
import Vue from "vue";
import Server from "src/server";
import Util from "src/util/util";

export default {
  name: "ag-geoInput-modal",

  components: {
    "ag-geoInput-buffer": Buffer,
    "ag-geoInput-distance": Distance,
    "ag-geoInput-geocode": Geocode,
    "ag-geoInput-nearestFeature": NearestFeature,
    "ag-geoInput-gisExtension": GISExtension,
    "ag-geoInput-intersect": Intersect,
    "ag-geoInput-project": Project,
    "ag-geoInput-reverseGeocode": ReverseGeocode
  },

  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean
  },

  data() {
    return {
      geoInput: null,
      reload: 0,
      isLoading: false,
      modalMessage: "",
      modalMessageClass: "",
      types: [
        { value: "buffer", text: "Buffer" },
        { value: "distance", text: "Distance" },
        { value: "geocode", text: "Geocode" },
        { value: "gisExtension", text: "GIS Extension" },
        { value: "intersect", text: "Intersect" },
        { value: "nearestFeature", text: "Nearest Feature" },
        { value: "project", text: "Project"},
        { value: "reverseGeocode", text: "Reverse Geocode" }
      ],
    };
  },

  computed: {

    name() {
      if (this.geoInput.name)
        return this.geoInput.name;
      
      return this.geoInput.shortname;
    },

    srcStr() {
      if (!this.geoInput.src || this.geoInput.src.length == 0) return "";

      var srcStr = "";
      for (var i = 0; i < this.geoInput.src.length; i++) {
        var src = this.geoInput.src[i];
        srcStr += src.shortname + ", ";
      }
      srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last ,
      return srcStr;
    },

    destName() {
      if (this.geoInput.dest) 
        return this.geoInput.dest.shortname;
      return "";
    },
  },

  watch: {},

  created() {},

  mounted() {},

  methods: {

    // UI Events

    cancelButton_click() {
      this.hide();
    },
    
    async saveButton_click() {
      this.modalMessage = "";

      // alert subcomponent
      if(this.geoInput.subtype) {
        var subcomponent = this.$refs[this.geoInput.subtype];
        subcomponent.prepareForSave();
      }

      var node = {
        object: this.geoInput,
        type: "geoInput"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {
        node: node
      });
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "geoInput",
          object: result.data.node
        };
        this.hide();
        this.$emit("updatedNode", updated);
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.geoInput,
        type: "geoInput"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {
        node: node
      });
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide();
    },

    async typeField_change() {
      this.geoInput.config = {};
    },

    // emitted Events

    // other

    async show() {
      await this.setGeoInput();
      await Vue.nextTick();        
      await this.reset();
      this.$modal.show("agGeoInputModal");
    },

    hide() {
      this.$modal.hide('agGeoInputModal');
    },

    async reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      if(!this.geoInput.config) 
        this.geoInput.config = {};

      // needs some time before refs are set
      setTimeout(() => {
        let subcomponent = this.$refs[this.geoInput.subtype];
        if (subcomponent) 
          subcomponent.reset();
      }, 250);
    },   

    async setGeoInput() {
        if(this.node && this.node.type == "geoInput") 
          this.geoInput = this.workflow.geoInputs.find((object) => object._id == this.node.object._id);
        else
          this.geoInput = null;
      },
  }
};
</script>






<style scoped lang="css">
</style>



// WEBPACK FOOTER //
// src/components/nodes/geoInputs/GeoInputModal.vue